export default __webpack_public_path__ + "static/media/cross.a0fbfa60.svg";